import { render, staticRenderFns } from "./coinOrder.vue?vue&type=template&id=2dde2942&scoped=true&"
import script from "./coinOrder.vue?vue&type=script&lang=js&"
export * from "./coinOrder.vue?vue&type=script&lang=js&"
import style0 from "./coinOrder.vue?vue&type=style&index=0&id=2dde2942&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde2942",
  null
  
)

export default component.exports